const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载 · 即点即播',
    desc: '采用全球 CDN 加速与智能预加载技术，高清播放在线不缓冲。点击播放按钮后 1 秒内开始播放，告别漫长等待，流畅观看超清画质无广告。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净观影 · 零广告打扰',
    desc: '窝窝影院坚持无广告观影理念，播放全程无任何弹窗、贴片或插播广告。您只需专注享受海量高清电影电视剧免费在线观看的纯粹乐趣。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新 · 片库常新',
    desc: '专业内容运营团队 7×24 小时不间断更新片源，每日更新不卡顿。热播剧集同步跟播，经典影片持续入库，确保您总能找到想看的精彩内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            平台优势
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            为什么选择窝窝影院
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 md:p-8 text-center hover:bg-background-200/70 transition-colors group"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200/70 transition-colors">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-lg mb-3">
                {f.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}